import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={37}
    height={38}
    viewBox="0 0 37 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.11538 24.2668L1.03845 28.3438C0.969881 28.4091 0.995516 28.5273 1.09108 28.5557L6.00126 30.0472C6.69785 30.2592 7.24063 30.8019 7.45248 31.4985L8.94403 36.4086C8.97233 36.5042 9.09059 36.5298 9.15594 36.4613L14.611 31.0063C10.5749 30.0037 7.24282 27.4875 5.11538 24.2668Z"
      fill="url(#paint0_linear_4437_324)"
    />
    <path
      d="M35.9616 28.3438L31.8846 24.2668C29.7724 27.4645 26.4506 29.9973 22.3889 31.0063L27.8439 36.4613C27.9093 36.5299 28.0275 36.5043 28.0558 36.4087L29.5474 31.4985C29.7593 30.8019 30.3021 30.2592 30.9987 30.0473L35.9088 28.5558C36.0047 28.5273 36.03 28.4089 35.9616 28.3438Z"
      fill="url(#paint1_linear_4437_324)"
    />
    <path
      d="M32.4636 15.4636C32.4636 7.76439 26.1999 1.5 18.5 1.5C10.8001 1.5 4.53638 7.76439 4.53638 15.4636C4.53638 22.4251 9.66195 28.2272 16.3542 29.2631C24.8314 30.5818 32.4636 23.9835 32.4636 15.4636ZM7.61525 18.8665C5.3124 11.504 10.856 4.06139 18.5 4.06139C27.039 4.06139 32.6831 13.2387 28.5206 20.9029C23.7153 29.718 10.6396 28.4865 7.61525 18.8665Z"
      fill="url(#paint2_linear_4437_324)"
    />
    <path
      d="M18.5 6.11206C13.3437 6.11206 9.14783 10.3073 9.14783 15.4635C9.14783 23.0496 17.7487 27.4736 23.9078 23.0889C25.2274 22.1522 26.3021 20.8717 26.9935 19.3756C29.8668 13.19 25.2864 6.11206 18.5 6.11206ZM23.2201 14.1518C23.1034 14.2384 17.4217 18.4554 17.3891 18.4796C16.9788 18.7854 16.395 18.7444 16.0301 18.3579C13.4203 15.5766 13.6291 15.7987 13.5665 15.7329C13.128 15.266 13.2195 14.5107 13.7682 14.1635C13.7688 14.1628 13.7695 14.1621 13.7702 14.1621C14.1776 13.9064 14.7211 13.9659 15.0622 14.3296C15.6141 14.9177 15.2426 14.5219 16.9003 16.288C17.079 16.1548 19.1817 14.5949 22.0744 12.4483C22.529 12.1106 23.1716 12.2056 23.5085 12.6602C23.8174 13.0747 23.8163 13.71 23.2201 14.1518Z"
      fill="url(#paint3_linear_4437_324)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4437_324"
        x1={14.6109}
        y1={36.5}
        x2={2.4472}
        y2={22.966}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4437_324"
        x1={36.0002}
        y1={36.5}
        x2={23.8364}
        y2={22.9659}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4437_324"
        x1={32.4636}
        y1={29.4315}
        x2={4.53208}
        y2={1.5043}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4437_324"
        x1={27.8662}
        y1={24.8253}
        x2={9.15295}
        y2={6.10694}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#223E76" />
        <stop offset={0.511069} stopColor="#365699" />
        <stop offset={1} stopColor="#2BA9B4" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
